import { render, staticRenderFns } from "./CInformacionOT.vue?vue&type=template&id=6aea1573&"
import script from "./CInformacionOT.vue?vue&type=script&lang=js&"
export * from "./CInformacionOT.vue?vue&type=script&lang=js&"
import style0 from "./CInformacionOT.vue?vue&type=style&index=0&id=6aea1573&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports